<div class="flex error" [ngClass]="{ 'error-show py-2 pr-2': fieldError && formError }">
	<uc-form-error-svg class="inline mt-0.5" />
	<small class="ml-1 text-sm text-red-500">{{ fieldError }}</small>
</div>
